import LogContact from './LogContact';
export default LogContact;
